import { Check, X } from 'lucide-react';
import type { Plan } from '../../../data/portfolio-examples';

/**
 * Cabeçalho de seção. Preço e nome do plano vêm juntos e no mesmo formato nas
 * três seções, para o visitante nunca precisar deduzir qual formato custa quanto.
 */
export default function PlanHeader({ plan }: { plan: Plan }) {
  return (
    <div className="ex-plan">
      <p className="ex-plan__price">{plan.price}</p>
      <h2 className="ex-plan__name" id={`${plan.anchor}-titulo`}>
        {plan.name}
      </h2>

      <p className="ex-plan__line">
        <Check className="ex-plan__icon ex-plan__icon--yes" size={22} strokeWidth={2.5} aria-hidden="true" />
        <span>
          <strong>Você recebe:</strong> {plan.receives}
        </span>
      </p>

      {plan.missing && (
        <p className="ex-plan__line">
          <X className="ex-plan__icon ex-plan__icon--no" size={22} strokeWidth={2.5} aria-hidden="true" />
          <span>{plan.missing}</span>
        </p>
      )}

      {plan.note && <p className="ex-plan__note">{plan.note}</p>}
    </div>
  );
}
